const EVENTS = {
  AUTH: {
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_FAIL: 'AUTH_FAIL'
  }
};

export { EVENTS };
